// Mirrors Nut_Controller_Plugin_AccountCheck::$controllersUsableInArrears (library/Nut/Controller/Plugin/AccountCheck.php)
const PATHS_ALLOWED_WHEN_EXPIRED = [
    '/setup/billing',
    '/my-account',
    '/no-access',
    '/auth/',
    '/sales-demo',
];

/**
 * Checks if the given path is allowed when the account is expired.
 * Used by the declarative <Redirect> in app-routes.tsx.
 */
export function isPathAllowedWhenExpired(pathname: string): boolean {
    return PATHS_ALLOWED_WHEN_EXPIRED.some((p) => pathname.startsWith(p));
}
